export default "__VITE_ASSET__79266a8d__"